(function () {
  function mkGalEscAttr(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function buildFabricGallerySlides(items) {
    return (items || []).map(function (it) {
      if (!it || !it.src) return '';
      if (it.type === 'video') {
        var poster = it.poster ? ' poster="' + mkGalEscAttr(it.poster) + '"' : '';
        return '<div class="mk-fabric-gallery__slide mk-fabric-gallery__slide--video is-loading">' +
          '<video src="' + mkGalEscAttr(it.src) + '"' + poster + ' autoplay muted loop playsinline preload="metadata"></video>' +
          '</div>';
      }
      return '<div class="mk-fabric-gallery__slide is-loading">' +
        '<img src="' + mkGalEscAttr(it.src) + '" alt="" loading="lazy">' +
        '</div>';
    }).join('');
  }

  function wireSlideLoading(track) {
    var slides = track.querySelectorAll('.mk-fabric-gallery__slide');
    Array.prototype.forEach.call(slides, function (slide) {
      var media = slide.querySelector('img, video');
      var done = function () {
        slide.classList.remove('is-loading');
        slide.classList.add('is-loaded');
      };
      if (!media) { done(); return; }
      if (media.tagName === 'IMG') {
        if (media.complete && media.naturalWidth) { done(); return; }
        media.addEventListener('load', done, { once: true });
        media.addEventListener('error', done, { once: true });
      } else {
        if (media.readyState >= 2) { done(); return; }
        media.addEventListener('loadeddata', done, { once: true });
        media.addEventListener('error', done, { once: true });
      }
    });
  }

  function updateGalleryState(gallery, fromScroll) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    // Elementet er ikke layoutet endnu (fx lige efter display-skift) — vent en frame,
    // ellers regnes idx/pile paa en 0-bred track.
    if (track.children.length > 0 && track.clientWidth === 0) {
      requestAnimationFrame(function () { updateGalleryState(gallery, fromScroll); });
      return;
    }
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    var pag = gallery.querySelector('[data-gallery-pagination]');
    var n = track.children.length;
    var w = track.clientWidth || 1;
    // gallery._idx er sandheden (sat af pile-klik). Ved brugerscroll/swipe opdateres
    // den fra scrollLeft. At udlede idx fra scrollLeft ved KLIK er upaalideligt, fordi
    // scroll-snap + async billedindlaesning kan flytte scrollLeft midt i et klik.
    var idx;
    if (fromScroll || typeof gallery._idx !== 'number') {
      idx = Math.round(track.scrollLeft / w);
    } else {
      idx = gallery._idx;
    }
    if (idx < 0) idx = 0;
    if (idx > n - 1) idx = n - 1;
    gallery._idx = idx;
    if (pag) {
      pag.style.setProperty('--mk-count', n || 1);
      pag.style.setProperty('--mk-active', idx);
      pag.style.display = n > 1 ? '' : 'none';
    }
    if (prev) prev.toggleAttribute('data-hidden', n <= 1 || idx <= 0);
    if (next) next.toggleAttribute('data-hidden', n <= 1 || idx >= n - 1);
  }

  function initFabricGallery(gallery) {
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    if (!gallery.dataset.mkGalleryInit) {
      gallery.dataset.mkGalleryInit = '1';
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { updateGalleryState(gallery, true); });
      });
      var snapTimer;
      var goTo = function (idx) {
        var n = track.children.length;
        var w = track.clientWidth || 1;
        if (idx < 0) idx = 0;
        if (idx > n - 1) idx = n - 1;
        gallery._idx = idx;
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: idx * w, behavior: 'smooth' });
        clearTimeout(snapTimer);
        snapTimer = setTimeout(function () { track.style.scrollSnapType = ''; }, 500);
        updateGalleryState(gallery);
      };
      var goRelative = function (delta) {
        var cur = typeof gallery._idx === 'number'
          ? gallery._idx
          : Math.round(track.scrollLeft / (track.clientWidth || 1));
        goTo(cur + delta);
      };
      gallery.mkGalleryGo = goRelative;
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { goRelative(-1); });
      if (next) next.addEventListener('click', function () { goRelative(1); });
      window.addEventListener('resize', function () { updateGalleryState(gallery); });
    }
    updateGalleryState(gallery);
  }

  function renderFabricGallery(gallery, items) {
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    var list = items || [];
    gallery.style.display = list.length ? '' : 'none';
    track.innerHTML = buildFabricGallerySlides(list);
    track.scrollLeft = 0;
    gallery._idx = 0;
    wireSlideLoading(track);
    initFabricGallery(gallery);
    requestAnimationFrame(function () { updateGalleryState(gallery); });
  }

  function autoInitSingleGalleries() {
    var galleries = document.querySelectorAll('[data-detail-gallery][data-stof-galleri]');
    Array.prototype.forEach.call(galleries, function (g) {
      if (g.dataset.mkGalleryRendered) return;
      g.dataset.mkGalleryRendered = '1';
      var items = [];
      try { items = JSON.parse(g.getAttribute('data-stof-galleri')) || []; } catch (e) {}
      renderFabricGallery(g, items);
    });
  }

  window.MKFabricGallery = {
    render: renderFabricGallery,
    init: initFabricGallery,
    buildSlides: buildFabricGallerySlides
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitSingleGalleries);
  } else {
    autoInitSingleGalleries();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var galleries = document.querySelectorAll('[data-detail-gallery]');
    for (var i = 0; i < galleries.length; i++) {
      var g = galleries[i];
      var drawer = g.closest('.mk-fabric-drawer');
      if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') continue;
      if (g.offsetParent === null) continue;
      if (typeof g.mkGalleryGo !== 'function') continue;
      var track = g.querySelector('[data-gallery-track]');
      if (!track || track.children.length < 2) continue;
      e.preventDefault();
      g.mkGalleryGo(e.key === 'ArrowLeft' ? -1 : 1);
      return;
    }
  });
})();

(function () {
  var DURABLE_MIN = 50000;
  var COLORFAST_MIN = 4;
  var PILLING_MIN = 4;
  var mkSortSeq = 0;

  function digits(s) {
    var n = parseInt(String(s == null ? '' : s).replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? null : n;
  }
  function firstNum(s) {
    var m = String(s == null ? '' : s).match(/\d+/);
    return m ? parseInt(m[0], 10) : null;
  }

  function readGroup(group, idx) {
    var swatches = Array.prototype.slice.call(group.querySelectorAll('.mk-drawer-swatch'));
    if (!swatches.length) return null;
    var first = swatches[0];
    var prices = swatches.map(function (s) { return parseInt(s.dataset.price, 10); }).filter(function (n) { return !isNaN(n); });
    var nameEl = group.querySelector('.mk-drawer-group__name');
    return {
      el: group,
      order: idx,
      betraek: (first.dataset.betraek || '').trim(),
      martindale: digits(first.dataset.martindale),
      pilling: firstNum(first.dataset.pilling),
      colorfast: firstNum(first.dataset.farveaegthed),
      price: prices.length ? Math.min.apply(null, prices) : null,
      name: (nameEl ? nameEl.textContent : '').trim(),
      count: swatches.length
    };
  }

  function sectionAnchorOf(group) {
    var el = group.previousElementSibling;
    while (el) {
      if (!(el.classList && el.classList.contains('mk-drawer-group'))) return el;
      el = el.previousElementSibling;
    }
    return null;
  }

  function initFilters(bar) {
    if (bar.dataset.mkFiltersInit) return;
    var body = bar.closest('.mk-fabric-drawer__body');
    if (!body) return;
    var groupEls = Array.prototype.slice.call(body.querySelectorAll('.mk-drawer-group'));
    var groups = groupEls.map(readGroup).filter(Boolean);
    if (groups.length < 2) return;
    bar.dataset.mkFiltersInit = '1';
    bar.hidden = false;

    var toggleBtn = bar.querySelector('[data-fabric-filters-toggle]');
    var panel = bar.querySelector('[data-fabric-filters-panel]');
    var badge = bar.querySelector('[data-fabric-active-count]');
    var clearBtn = bar.querySelector('[data-fabric-filters-clear]');
    var countEl = bar.querySelector('[data-fabric-count]');
    var typeSec = bar.querySelector('[data-facet-type]');
    var typeList = bar.querySelector('[data-facet-type-list]');
    var sortRadios = Array.prototype.slice.call(bar.querySelectorAll('[data-fabric-sort]'));

    if (sortRadios.length) {
      var groupName = 'mk-fabric-sort-' + (++mkSortSeq);
      sortRadios.forEach(function (r) { r.name = groupName; });
      var anyChecked = sortRadios.some(function (r) { return r.checked; });
      if (!anyChecked) {
        var def = null;
        for (var si = 0; si < sortRadios.length; si++) {
          if (sortRadios[si].value === 'default') { def = sortRadios[si]; break; }
        }
        (def || sortRadios[0]).checked = true;
      }
    }

    var selectedBetraek = {};

    if (toggleBtn && panel) {
      toggleBtn.addEventListener('click', function () {
        var open = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', open);
        toggleBtn.classList.toggle('is-open', open);
        toggleBtn.setAttribute('aria-expanded', String(open));
      });
    }

    Array.prototype.forEach.call(bar.querySelectorAll('[data-facet-toggle]'), function (head) {
      head.addEventListener('click', function () {
        var sec = head.closest('[data-facet]');
        if (!sec) return;
        var open = !sec.classList.contains('is-open');
        sec.classList.toggle('is-open', open);
        head.setAttribute('aria-expanded', String(open));
      });
    });

    function addOption(list, label, isChecked, onToggle) {
      var lab = document.createElement('label');
      lab.className = 'mk-facet__opt text-sm';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = !!isChecked();
      var span = document.createElement('span');
      span.textContent = label;
      lab.appendChild(input);
      lab.appendChild(span);
      input.addEventListener('change', function () { onToggle(); apply(); });
      list.appendChild(lab);
    }

    var betraekVals = [];
    groups.forEach(function (g) {
      if (g.betraek && betraekVals.indexOf(g.betraek) === -1) betraekVals.push(g.betraek);
    });
    betraekVals.sort();

    if (typeList && betraekVals.length > 1) {
      betraekVals.forEach(function (val) {
        addOption(typeList, val,
          function () { return selectedBetraek[val]; },
          function () { selectedBetraek[val] = !selectedBetraek[val]; });
      });
      if (typeSec) typeSec.hidden = false;
    }

    function activeBetraek() {
      var out = [];
      for (var k in selectedBetraek) { if (selectedBetraek[k]) out.push(k); }
      return out;
    }

    function activeCount() {
      return activeBetraek().length;
    }

    function matches(g) {
      var b = activeBetraek();
      if (b.length && b.indexOf(g.betraek) === -1) return false;
      return true;
    }

    function currentSort() {
      for (var i = 0; i < sortRadios.length; i++) { if (sortRadios[i].checked) return sortRadios[i].value; }
      return 'default';
    }

    function comparator(mode) {
      var nullLast = function (a, b) { return (a === null) - (b === null); };
      switch (mode) {
        case 'price-asc': return function (a, b) { return nullLast(a.price, b.price) || (a.price - b.price) || (a.order - b.order); };
        case 'price-desc': return function (a, b) { return nullLast(a.price, b.price) || (b.price - a.price) || (a.order - b.order); };
        case 'durability': return function (a, b) { return nullLast(a.martindale, b.martindale) || (b.martindale - a.martindale) || (a.order - b.order); };
        case 'colorfastness': return function (a, b) { return nullLast(a.colorfast, b.colorfast) || (b.colorfast - a.colorfast) || (a.order - b.order); };
        default: return function (a, b) { return a.order - b.order; };
      }
    }

    function apply() {
      var visible = 0;
      groups.forEach(function (g) {
        var ok = matches(g);
        g.el.hidden = !ok;
        if (ok) visible += g.count;
      });

      var cmp = comparator(currentSort());
      var bySection = [];
      groups.forEach(function (g) {
        var key = sectionAnchorOf(g.el);
        var bucket = null;
        for (var i = 0; i < bySection.length; i++) { if (bySection[i].key === key) { bucket = bySection[i]; break; } }
        if (!bucket) { bucket = { key: key, items: [] }; bySection.push(bucket); }
        bucket.items.push(g);
      });
      bySection.forEach(function (bucket) {
        var sorted = bucket.items.slice().sort(cmp);
        var parent = sorted[0].el.parentElement;
        if (!parent) return;
        var cursor = bucket.key || bucket.items[0].el.previousElementSibling;
        sorted.forEach(function (g) {
          if (cursor) { cursor.after(g.el); } else { parent.insertBefore(g.el, parent.firstChild); }
          cursor = g.el;
        });
      });

      var n = activeCount();
      if (badge) { badge.textContent = n; badge.hidden = n === 0; }
      if (countEl) {
        var tpl = countEl.dataset.countTemplate || '__N__';
        countEl.textContent = tpl.replace('__N__', visible);
      }
      if (clearBtn) clearBtn.hidden = n === 0;
    }

    sortRadios.forEach(function (r) { r.addEventListener('change', apply); });
    if (clearBtn) clearBtn.addEventListener('click', function () {
      selectedBetraek = {};
      Array.prototype.forEach.call(bar.querySelectorAll('.mk-facet__opt input[type="checkbox"]'), function (c) { c.checked = false; });
      if (sortRadios.length) sortRadios[0].checked = true;
      apply();
    });

    apply();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-filters]'), initFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

function getVariantFromOptionArray(product, options) {
  return product.variants.find(variant =>
    options.every((option, index) => variant.options[index] === option)
  ) || null;
}

function getVariantFromId(product, id) {
  return product.variants.find(v => v.id === id) || null;
}

function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.MinimogSettings?.money_format || '{{amount}} kr';

  function addCommas(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;

  const key = match[1];
  let value = '';

  switch (key) {
    case 'amount':
      value = addCommas((cents / 100).toFixed(2).replace('.', ','));
      break;
    case 'amount_no_decimals':
      value = addCommas(Math.floor(cents / 100));
      break;
    case 'amount_with_comma_separator':
      value = addCommas((cents / 100).toFixed(2));
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = addCommas(Math.floor(cents / 100));
      break;
    default:
      value = addCommas((cents / 100).toFixed(2));
  }

  return formatString.replace(placeholderRegex, value);
}

function qsa(selector, root = document) {
  return Array.from(root.querySelectorAll(selector));
}

if (!customElements.get('mk-option-group')) {
  class MkOptionGroup extends HTMLElement {
    constructor() {
      super();
      this.selectedSpan = this.querySelector('.selected-value');
      this.addEventListener('change', this.onSelect.bind(this));
      this.initSwatchHover();
    }

    onSelect() {
      const type = this.dataset.pickerField;
      if (type === 'select') {
        this.value = this.querySelector('select')?.value;
      } else {
        this.value = qsa('input', this).find(r => r.checked)?.value;
      }
      this.setAttribute('data-selected-value', this.value || '');
      if (this.selectedSpan) this.selectedSpan.textContent = this.value;
    }

    initSwatchHover() {
      if (!this.selectedSpan) return;
      const span = this.selectedSpan;

      const options = qsa('.mk-option', this);
      options.forEach(opt => {
        opt.addEventListener('mouseenter', () => {
          const val = opt.dataset.value;
          if (val) span.textContent = val;
        });
        opt.addEventListener('mouseleave', () => {
          span.textContent = this.dataset.selectedValue || '';
        });
      });
    }

    get selectedValue() {
      return this.dataset.selectedValue || '';
    }
  }

  customElements.define('mk-option-group', MkOptionGroup);
}

if (!customElements.get('mk-variant-picker')) {
  class MkVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest('[data-variant-picker]');
      this.productInfo = this.closest('.sf-prod__info');
      // Tidsstempel for skeleton min-display (MIN_SKELETON_MS) — uden den
      // flickrer skeleton væk når fetch returnerer fra cache.
      this._initStartedAt = (typeof performance !== 'undefined' && performance.now)
        ? performance.now()
        : Date.now();
      this.init();
    }

    async init() {
      this.productId = this.container.dataset.productId;
      this.sectionId = this.container.dataset.section;
      this.productUrl = this.container.dataset.productUrl;
      this.productHandle = this.container.dataset.productHandle;
      this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`);
      this.enableVariantGroupImages = this.container.dataset.enableVariantGroupImages === 'true';

      const fetchedData = await this.fetchProductJson();
      const tp = window._themeProducts || {};
      const localData = tp[this.productId] || tp[Number(this.productId)] || {};

      this.productData = Object.assign(fetchedData, localData);
      this.variantMeta = localData.variantMeta || {};

      this.variantData = this.getJsonBlock('#productVariants');
      if (this.enableVariantGroupImages) {
        this.variantGroupImages = this.getJsonBlock('#variantGroup');
      }

      // URL'ens ?variant= har højeste prioritet — [name="id"] inputtet sættes
      // af Liquid til first_available_variant.id og ignorerer URL, så vi
      // parser selv for at respektere deeplinks.
      let initialVariantId = null;
      try {
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        if (urlVariant) initialVariantId = Number(urlVariant);
      } catch (e) {}
      if (!initialVariantId) {
        const variantInput = this.section?.querySelector('[name="id"]');
        initialVariantId = Number(variantInput?.value);
      }
      this.currentVariant = this.productData.variants.find(v => v.id === initialVariantId)
        || this.productData.variants.find(v => v.available)
        || this.productData.variants[0];
      this.productData.current_variant_id = this.currentVariant?.id;
      this.productData.initialVariant = this.currentVariant;

      if (this.currentVariant) {
        // Liquid kan rendere option.selected_value inkonsistent (især for
        // design-selv-varianter), så vi tvinger UI'en til at matche den
        // variant JS faktisk har valgt.
        this.options = [...this.currentVariant.options];
        this.syncSelectedOptions();

        this.resolveVariantMedia(this.currentVariant.id);
        this.hideSoldOutAndUnavailableOptions();
        this.updateStockCountdown(this.currentVariant);
        this.updateButton(!this.currentVariant.available, '', false);
        requestAnimationFrame(() => this.updateDesignSelvNotice());
        this.updateSamplesLink();
      }

      this.findMediaGallery();
      this.initSwatchVisuals();
      this.initFabricDrawer();
      this.initLinkedProductDropdown();
      this.initLegModal();
      this.initDesignSelvTerms();
      // initAutoFitSwatches kalder revealSwatchesAfterPreload() efter fit, så
      // skeleton først fader EFTER initSwatchVisuals har sat bg-images OG
      // autoFit har skjult overflow-swatches.
      this.initAutoFitSwatches();

      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      this.getSelectedOptions();
      this.resolveVariant();
      this.updateButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();

      if (!this.currentVariant) {
        this.updateButton(true, '', true);
        this.setUnavailable();
      } else {
        this.resolveVariantMedia(this.currentVariant.id);
        this.updateMedia();
        this.updateBrowserHistory();
        this.updateVariantInput();
        this.updateProductMeta();
        this.updatePrice();
        this.updateButton(!this.currentVariant.available, window.MinimogStrings?.soldOut);
        this.hideSoldOutAndUnavailableOptions();
        this.updateStockCountdown(this.currentVariant);
        this.updateDesignSelvNotice();
        this.updateLinkedProductImages();
        this.updateSamplesLink();
      }

      window.MinimogEvents?.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this);
    }

    updateSamplesLink() {
      const links = document.querySelectorAll('[data-mk-samples-link]');
      if (!links.length || !this.currentVariant) return;
      if (!this._samplesMap) {
        const mapEl = document.querySelector('[data-mk-fabric-samples-map]');
        try {
          this._samplesMap = mapEl ? JSON.parse(mapEl.textContent) : {};
        } catch (e) {
          this._samplesMap = {};
        }
      }
      const firstWord = (this.currentVariant.title.split(' ')[0] || '').toLowerCase();
      const matchedUrl = this._samplesMap[firstWord];
      links.forEach(link => {
        if (matchedUrl) link.href = matchedUrl;
      });
    }

    updateDesignSelvNotice() {
      const notice = this.container.querySelector('#mk-ds-notice');
      if (!notice || !this.currentVariant) return;
      // design-selv-flaget ligger i variantMeta (ikke på selve variant-objektet).
      // Autoritativt og virker uanset om valget kom fra hovedpicker eller drawer,
      // i modsætning til en DOM-swatch-baseret test (drawer-swatchene har ikke
      // data-design-selv, og hovedpicker'en dedup'er farve-værdier).
      const meta = this.variantMeta && this.variantMeta[String(this.currentVariant.id)];
      notice.classList.toggle('mk-ds-notice--visible', !!(meta && meta.designSelv));
    }

    initDesignSelvTerms() {
      const termsModal = this.container.querySelector('#mk-ds-terms-modal');
      if (!termsModal) return;

      document.body.appendChild(termsModal);
      this.dsTermsModal = termsModal;

      // Both container (product page notice) og fabric drawer (flyttet til body)
      // har triggers — derfor to scopes.
      const openBtns = [
        ...qsa('[data-open-ds-terms]', this.container),
        ...(this.fabricDrawer ? qsa('[data-open-ds-terms]', this.fabricDrawer) : [])
      ];
      openBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          termsModal.setAttribute('aria-hidden', 'false');
        });
      });

      qsa('[data-close-ds-terms]', termsModal).forEach(el => {
        el.addEventListener('click', () => {
          termsModal.setAttribute('aria-hidden', 'true');
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && termsModal.getAttribute('aria-hidden') === 'false') {
          termsModal.setAttribute('aria-hidden', 'true');
        }
      });
    }

    getSelectedOptions() {
      const groups = qsa('mk-option-group', this);
      this.options = groups.map(group => {
        const type = group.dataset.pickerField;
        if (type === 'select') return group.querySelector('select')?.value;
        return qsa('input', group).find(r => r.checked)?.value;
      });
    }

    resolveVariant() {
      let variant = getVariantFromOptionArray(this.productData, this.options);
      let options = [...this.options];

      // Fallback: ingen exact match → prøv at fjerne sidste option(s) så
      // user-selection bliver tættest muligt på en gyldig variant.
      if (!variant) {
        options.pop();
        variant = getVariantFromOptionArray(this.productData, options);
        if (!variant) {
          options.pop();
          variant = getVariantFromOptionArray(this.productData, options);
        }
        if (variant) {
          this.options = [...variant.options];
          this.syncSelectedOptions();
        }
      }

      this.currentVariant = variant;
    }

    syncSelectedOptions() {
      qsa('mk-option-group', this).forEach((group, index) => {
        const expectedValue = this.options[index];
        if (expectedValue == null) return;
        // Force-uncheck først — Liquid kan have rendret flere som checked.
        const allInputs = group.querySelectorAll('input[type="radio"]');
        allInputs.forEach(r => { r.checked = false; });
        const target = group.querySelector(`input[value="${CSS.escape(expectedValue)}"]`);
        if (target) target.checked = true;
        if (group.dataset.selectedValue !== expectedValue) {
          group.setAttribute('data-selected-value', expectedValue);
          if (group.selectedSpan) group.selectedSpan.textContent = expectedValue;
        }
      });
      this.syncDrawerSwatches();
    }

    syncDrawerSwatches() {
      if (!this.fabricDrawer) return;
      qsa('.mk-drawer-swatch__image input[type="radio"]', this.fabricDrawer).forEach(r => { r.checked = false; });
      (this.options || []).forEach((value, index) => {
        if (value == null) return;
        const position = index + 1;
        const inputs = this.fabricDrawer.querySelectorAll(
          `.mk-drawer-swatch__image[data-option-position="${position}"] input[value="${CSS.escape(value)}"]`
        );
        inputs.forEach(r => { r.checked = true; });
      });
    }

    findMediaGallery() {
      // Gallery rendres async — short poll med 30-attempt fallback.
      let attempts = 0;
      const check = setInterval(() => {
        const galleries = this.section?.querySelectorAll('media-gallery');
        if (galleries?.length || attempts++ > 30) {
          clearInterval(check);
          galleries?.forEach(media => {
            if (window.getComputedStyle(media).display !== 'none') {
              this.layout = media.layout;
              this.media = media;
              if (media.mediaMode === 'slider') {
                this.slides = media.slider?.slides;
                this.slidesNav = media.navSlider?.slides;
              } else {
                this.mediaItems = media.querySelectorAll('.sf-prod-media-item');
              }
              if (this.enableVariantGroupImages && this.variantGroupImages?.enable) {
                this.updateMedia();
              }
            }
          });
        }
      }, 100);
    }

    resolveVariantMedia(variantId) {
      if (this.variantGroupImages?.enable) {
        const mapping = this.variantGroupImages.mapping?.find(v => Number(v.id) === variantId);
        this.currentVariantMedia = mapping?.media || [];
      }
    }

    updateMedia() {
      if (!this.currentVariant?.featured_media) return;

      if (this.variantGroupImages?.enable && this.currentVariantMedia?.length > 0) {
        if (this.media?.mediaMode === 'slider') {
          this.updateSliderMedia();
        } else {
          this.updateGridMedia();
        }
        const newElements = this.currentVariantMedia
          .map(id => this.media?.productData?.media?.find(m => m.id === Number(id)))
          .filter(Boolean)
          .sort((a, b) => a.position - b.position);
        this.media?.addEventToMainMedias?.();
        this.media?.initLightbox?.(newElements);
      } else {
        this.media?.setActiveMedia?.(this.currentVariant);
      }
    }

    updateSliderMedia() {
      let mainItems = [], navItems = [];
      let idx = 0, navIdx = 0;

      this.slides?.forEach(slide => {
        const mediaId = slide.querySelector('[data-media-id]')?.dataset.mediaId;
        if (this.currentVariantMedia.includes(mediaId) || !slide.classList.contains('media-type-image')) {
          slide.dataset.swiperSlideIndex = idx;
          slide.dataset.index = idx++;
          if (mainItems.length === 0) slide.classList.add('swiper-slide-active');
          mainItems.push(slide);
        }
      });

      this.media.slider?.removeAllSlides();
      this.media.slider?.appendSlide(mainItems);
      this.media.slider?.slideToLoop(0);
      this.media?.handleSlideChange?.();

      this.slidesNav?.forEach(slide => {
        const mediaId = slide.querySelector('[data-media-id]')?.dataset.mediaId;
        if (this.currentVariantMedia.includes(mediaId) || !slide.classList.contains('media-type-image')) {
          slide.dataset.swiperSlideIndex = navIdx;
          slide.dataset.index = navIdx++;
          if (navItems.length === 0) slide.classList.add('swiper-slide-thumb-active');
          navItems.push(slide);
        }
      });

      this.media.navSlider?.removeAllSlides();
      this.media.navSlider?.appendSlide(navItems);
      this.media.navSlider?.slideToLoop(0);
      this.media?.removeAttribute('data-media-loading');
      if (this.media.firstElementChild) this.media.firstElementChild.style.opacity = 1;
    }

    updateGridMedia() {
      // Re-query mediaItems hver gang — den initielle reference bliver stale
      // hvis tidligere update flyttede noder rundt eller skjulte dem.
      const items = this.media?.querySelectorAll('.sf-prod-media-item');
      if (!items?.length) return;

      // Vores layout-2 markup har ikke .sf-prod-media__wrapper. Find wrapperen
      // som direkte parent på første media-item — robust uanset class-navne.
      const wrapper = items[0].parentElement;
      const variantSet = (this.currentVariantMedia || []).map(String);
      const useFilter = variantSet.length > 0;
      const mainItems = [];
      let idx = 0;

      items.forEach(item => {
        const innerEl = item.querySelector('[data-media-id]');
        const mediaId = String(innerEl?.dataset?.mediaId || item.dataset?.mediaId || '');
        const isImage = item.classList.contains('media-type-image');
        const include = !isImage || !useFilter || variantSet.includes(mediaId);

        if (include) {
          item.hidden = false;
          item.dataset.index = idx++;
          if (this.layout === 'layout-2') {
            item.classList.remove('col-span-2');
            if ((Number(item.dataset.index) % 3) === 0) item.classList.add('col-span-2');
          }
          mainItems.push(item);
        } else {
          item.hidden = true;
        }
      });

      if (wrapper && mainItems.length) {
        // append() flytter eksisterende noder (uden klone), så event listeners bevares
        mainItems.forEach(item => wrapper.append(item));
      }
      this.media?.removeAttribute('data-media-loading');
      if (this.media?.firstElementChild) this.media.firstElementChild.style.opacity = 1;
    }


    updatePrice() {
      const money_format = window.MinimogSettings?.money_format;
      const { compare_at_price, price, unit_price_measurement } = this.currentVariant;
      const onSale = compare_at_price && compare_at_price > price;
      const soldOut = !this.currentVariant.available;

      const priceWrapper = this.productInfo?.querySelector('.f-price');
      const salePrice = this.productInfo?.querySelector('.f-price-item--sale');
      const compareAtPrices = qsa('.f-price-item--regular', this.productInfo);
      const unitPrice = this.productInfo?.querySelector('.f-price__unit');
      const saleBadge = this.productInfo?.querySelector('.f-price__badge-sale');
      const saleAmount = this.productInfo?.querySelector('[data-saved-price]');

      if (priceWrapper) {
        priceWrapper.classList.toggle('f-price--on-sale', onSale);
        priceWrapper.classList.toggle('f-price--sold-out', soldOut);
        priceWrapper.classList.remove('visibility-hidden');
      }

      if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

      compareAtPrices.forEach(el => {
        el.innerHTML = formatMoney(compare_at_price > price ? compare_at_price : price, money_format);
      });

      if (saleBadge && compare_at_price > price && saleAmount) {
        const saving = Math.floor((compare_at_price - price) * 100 / compare_at_price);
        saleAmount.textContent = saving + '%';
      }

      if (unit_price_measurement && unitPrice) {
        unitPrice.classList.remove('f-hidden');
        const baseUnit = unit_price_measurement.reference_value === 1
          ? unit_price_measurement.reference_unit
          : unit_price_measurement.reference_value + unit_price_measurement.reference_unit;
        unitPrice.innerHTML = `<span>${formatMoney(this.currentVariant.unit_price, money_format)}</span>/<span>${baseUnit}</span>`;
      } else {
        unitPrice?.classList.add('f-hidden');
      }
    }


    updateButton(disable = true, text = '', modifyClass = true) {
      const productForms = qsa(`.product-form-${this.sectionId}`);
      productForms.forEach(form => {
        const addBtn = form.querySelector('[name="add"]');
        const dynamicCheckout = form.querySelector('.prod__dynamic_checkout');
        const addBtnText = form.querySelector('[name="add"] > span.atc-text');
        const preorder = form.dataset.preorder;
        if (!addBtn) return;

        if (disable) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.classList.add('disabled');
          dynamicCheckout?.classList?.add?.('disabled');
          if (text) addBtnText.textContent = text;
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.classList.remove('disabled');
          dynamicCheckout?.classList?.remove?.('disabled');
          addBtnText.textContent = preorder === 'true'
            ? (window.MinimogStrings?.preorder || 'Forudbestil')
            : (window.MinimogStrings?.addToCart || 'Læg i kurv');
        }
      });
    }


    updateProductMeta() {
      const { available, sku } = this.currentVariant;
      const productSku = this.section?.querySelector('[data-variant-sku]');
      const productAvailability = this.section?.querySelector('[data-availability]');

      if (productSku) productSku.textContent = sku || (window.MinimogStrings?.noSku || '');
      if (productAvailability) {
        productAvailability.innerText = available
          ? (window.MinimogStrings?.inStock || 'På lager')
          : (window.MinimogStrings?.outOfStock || 'Ikke på lager');
        productAvailability.classList.toggle('prod__availability--outofstock', !available);
      }
    }


    hideSoldOutAndUnavailableOptions() {
      const variant = this.currentVariant;
      if (!variant) return;

      const optionNodes = qsa('.mk-option', this);
      const { variants, options: { length: maxOptions } } = this.productData;

      optionNodes.forEach(node => {
        const { optionPosition, value } = node.dataset;
        const pos = Number(optionPosition);
        let matchVariants = [];

        if (pos === maxOptions) {
          const opts = [...variant.options];
          opts[maxOptions - 1] = value;
          const match = getVariantFromOptionArray(this.productData, opts);
          if (match) matchVariants.push(match);
        } else {
          matchVariants = variants.filter(v =>
            v.options[pos - 1] === value &&
            v.options[pos - 2] === variant[`option${pos - 1}`]
          );
        }

        matchVariants = matchVariants.filter(Boolean);

        if (matchVariants.length) {
          node.classList.remove('mk-option--unavailable');
          const isSoldOut = matchVariants.every(v => !v.available);
          node.classList.toggle('mk-option--soldout', isSoldOut);
        } else {
          node.classList.add('mk-option--unavailable');
        }
      });
    }


    updateBrowserHistory() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.productUrl}?variant=${this.currentVariant.id}`);
    }


    updateVariantInput() {
      const forms = qsa(`#product-form-${this.sectionId}, #product-form-installment`);
      forms.forEach(form => {
        const input = form.querySelector('[name="id"]');
        if (input) {
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }


    updatePickupAvailability() {
      const pickup = this.section?.querySelector('pickup-availability');
      if (!pickup) return;
      if (this.currentVariant?.available) {
        pickup.fetchAvailability(this.currentVariant.id);
      } else {
        pickup.removeAttribute('available');
        pickup.innerHTML = '';
      }
    }


    removeErrorMessage() {
      const section = this.closest('section');
      const productForm = section?.querySelector('product-form');
      productForm?.handleErrorMessage?.();
    }


    setUnavailable() {
      const form = document.getElementById(`product-form-${this.sectionId}`);
      const addBtnText = form?.querySelector('[name="add"] > span.atc-text');
      const priceWrapper = this.section?.querySelector('.f-price');
      if (addBtnText) addBtnText.textContent = window.MinimogStrings?.unavailable || 'Ikke tilgængelig';
      if (priceWrapper) priceWrapper.classList.add('visibility-hidden');
    }


    updateStockCountdown(variant) {
      const countdown = this.productInfo?.querySelector('.prod__stock-countdown');
      if (!countdown) return;

      countdown.classList.toggle('hidden', !variant.available);

      if (countdown.dataset.countdownType === 'use_quantity') {
        const numberEl = countdown.querySelector('[data-countdown-number]');
        if (numberEl) {
          numberEl.textContent = variant.inventory_quantity > 0
            ? variant.inventory_quantity
            : (variant.id.toString().split('')[13] || 0) - -1;
        }
      }
    }


    initSwatchVisuals() {
      const { _colorSwatches = [], _imageSwatches = [] } = window.MinimogSettings || {};

      qsa('.mk-option', this).forEach(node => {
        const { optionType, optionPosition, value } = node.dataset;
        if (!value) return;

        const valueLower = value.toLowerCase();
        // Find variant matching this option value — prefer one with stof_thumbnail
        const allMatches = this.variantData?.filter(v => v[`option${optionPosition}`] === value) || [];
        const variantWithThumb = allMatches.find(v => this.variantMeta[String(v.id)]?.stofThumbnail);
        const variantMatch = variantWithThumb || allMatches[0];
        const variantImage = variantMatch?.featured_image?.src
          ? variantMatch.featured_image.src.replace(/(\.[^.]+)$/, '_100x$1')
          : '';
        const customImage = _imageSwatches.find(i => i.key === valueLower)?.value;
        const customColor = _colorSwatches.find(c => c.key === valueLower)?.value;

        // Check for stof_thumbnail from variantMeta (keys are strings in JSON)
        const meta = variantMatch ? this.variantMeta[String(variantMatch.id)] : null;
        const stofThumb = meta?.stofThumbnail;

        const label = node.querySelector('label');
        if (!label) return;

        // Skip if Liquid already set background-image (stof_thumbnail)
        if (label.style.backgroundImage) {
          label.classList.add('has-bg-img');
          return;
        }

        if (stofThumb || variantImage || customImage) label.classList.add('has-bg-img');

        switch (optionType) {
          case 'image':
            label.style.backgroundImage = `url(${stofThumb || variantImage || customImage || ''})`;
            break;
          case 'color':
            label.style.backgroundColor = customColor || valueLower;
            if (customImage) label.style.backgroundImage = `url(${customImage})`;
            break;
          default:
            if (stofThumb || customImage || variantImage) {
              label.style.backgroundImage = `url(${stofThumb || customImage || variantImage})`;
            }
            break;
        }
      });
    }


    revealSwatchesAfterPreload() {
      const wraps = qsa('.mk-swatches-wrap', this.container);
      if (!wraps.length) return;

      const MIN_SKELETON_MS = 600; // garanteret min-display så skeleton ikke flickrer
      const now = (typeof performance !== 'undefined' && performance.now)
        ? performance.now()
        : Date.now();
      const elapsed = now - (this._initStartedAt || 0);
      const minDelay = Math.max(0, MIN_SKELETON_MS - elapsed);

      wraps.forEach(wrap => {
        const collapsed = wrap.querySelector('.mk-swatches--collapsed');
        if (!collapsed) {
          setTimeout(() => wrap.classList.add('is-ready'), minDelay);
          return;
        }

        // Samle bg-image URLs på synlige labels (efter initSwatchVisuals har
        // sat dem). Preload + decode atomisk, så swatches er pixel-klar i
        // samme frame skeleton fader.
        const labels = qsa('.mk-option:not([data-overflow-hidden]) label', collapsed);
        const urls = [];
        labels.forEach(label => {
          const bg = label.style.backgroundImage;
          if (!bg || bg === 'none') return;
          const m = bg.match(/url\(["']?([^"')]+)/);
          if (m) urls.push(m[1]);
        });

        // Reveal venter både på min-display tid OG decode af alle bg-images.
        // Bruger Promise.all så vi venter på det seneste signal.
        const preloadDone = urls.length === 0
          ? Promise.resolve()
          : Promise.all(urls.map(url => new Promise(resolve => {
              const img = new Image();
              img.src = url;
              if (img.decode) {
                img.decode().then(resolve).catch(resolve);
              } else {
                img.onload = img.onerror = resolve;
              }
              // Per-image safety timeout så slow-loading image ikke blokerer
              setTimeout(resolve, 2000);
            })));
        const minTimeDone = new Promise(resolve => setTimeout(resolve, minDelay));

        Promise.all([preloadDone, minTimeDone]).then(() => {
          void collapsed.offsetHeight; // force reflow så browseren har bg-images klar
          requestAnimationFrame(() => {
            requestAnimationFrame(() => wrap.classList.add('is-ready'));
          });
        });

        // Hard safety net — uanset hvad, reveal efter 3s fra nu
        setTimeout(() => {
          if (!wrap.classList.contains('is-ready')) wrap.classList.add('is-ready');
        }, 3000);
      });
    }


    fetchProductJson() {
      return fetch(this.container.dataset.productUrl + '.js').then(r => r.json());
    }

    getJsonBlock(selector) {
      const el = this.container.querySelector(`${selector}[type="application/json"]`);
      return el ? JSON.parse(el.textContent) : null;
    }


    initFabricDrawer() {
      const drawer = this.container.querySelector('#mk-fabric-drawer');
      if (!drawer) return;

      // Reparent til body for at undgå stacking context-issues; CSS custom
      // properties skal kopieres ned da drawer forlader container-scope.
      const containerStyle = getComputedStyle(this.container);
      drawer.style.setProperty('--mk-swatch-size', containerStyle.getPropertyValue('--mk-swatch-size'));
      drawer.style.setProperty('--mk-swatch-radius', containerStyle.getPropertyValue('--mk-swatch-radius'));
      drawer.style.setProperty('--mk-border-width', containerStyle.getPropertyValue('--mk-border-width'));
      document.body.appendChild(drawer);
      this.fabricDrawer = drawer;

      qsa('[data-open-fabric-drawer]', this.container).forEach(btn => {
        btn.addEventListener('click', () => this.openFabricDrawer());
      });

      qsa('[data-open-fabric-detail]', this.container).forEach(btn => {
        btn.addEventListener('click', () => {
          const browseView = drawer.querySelector('[data-drawer-view="browse"]');
          const detailView = drawer.querySelector('[data-drawer-view="detail"]');
          const currentVariantId = this.currentVariant?.id;
          this.openFabricDrawer();
          if (browseView && detailView && currentVariantId) {
            this.showFabricDetail(currentVariantId, browseView, detailView);
          }
        });
      });

      qsa('[data-close-fabric-drawer]', drawer).forEach(el => {
        el.addEventListener('click', () => this.closeFabricDrawer());
      });

      this.initStickyDsBanner(drawer);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
          this.closeFabricDrawer();
        }
      });

      qsa('.mk-option input[type="radio"]', drawer).forEach(radio => {
        radio.addEventListener('change', () => {
          const value = radio.value;
          const groups = qsa('mk-option-group', this);

          const optionPos = radio.closest('.mk-option')?.dataset.optionPosition;
          const targetGroup = optionPos
            ? groups.find((g, i) => String(i + 1) === optionPos)
            : groups[0];

          if (!targetGroup) return;

          const mainRadio = qsa('input[type="radio"]', targetGroup).find(r => r.value === value);
          if (mainRadio) mainRadio.checked = true;

          targetGroup.setAttribute('data-selected-value', value);
          if (targetGroup.selectedSpan) targetGroup.selectedSpan.textContent = value;

          this.options = groups.map((group, i) => {
            if (group === targetGroup) return value;
            const type = group.dataset.pickerField;
            if (type === 'select') return group.querySelector('select')?.value;
            const checked = qsa('input', group).find(r => r.checked);
            return checked?.value || group.dataset.selectedValue;
          });

          this.resolveVariant();
          this.updateButton(true, '', false);
          this.updatePickupAvailability();
          this.removeErrorMessage();

          if (!this.currentVariant) {
            this.updateButton(true, '', true);
            this.setUnavailable();
          } else {
            this.resolveVariantMedia(this.currentVariant.id);
            this.updateMedia();
            this.updateBrowserHistory();
            this.updateVariantInput();
            this.updateProductMeta();
            this.updatePrice();
            this.updateButton(!this.currentVariant.available, window.MinimogStrings?.soldOut);
            this.hideSoldOutAndUnavailableOptions();
            this.updateStockCountdown(this.currentVariant);
            this.updateDesignSelvNotice();
            this.updateLinkedProductImages();
            this.updateSamplesLink();
          }

          window.MinimogEvents?.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this);

          // Paa mobil daekker draweren produktbilledet, saa man ikke kan se varianten
          // skifte: luk den ved valg. Paa desktop bliver den aaben, saa man kan
          // klikke sig gennem varianter og se billedet skifte ved siden af.
          if (window.matchMedia('(max-width: 767px)').matches) {
            this.closeFabricDrawer();
          }
        });
      });

      const drawerGroups = qsa('mk-option-group', this);
      qsa('.mk-option', drawer).forEach(opt => {
        opt.addEventListener('mouseenter', () => {
          const val = opt.dataset.value;
          drawerGroups.forEach(group => {
            if (group.selectedSpan) group.selectedSpan.textContent = val;
          });
        });
        opt.addEventListener('mouseleave', () => {
          drawerGroups.forEach(group => {
            if (group.selectedSpan) group.selectedSpan.textContent = group.dataset.selectedValue || '';
          });
        });
      });

      const browseView = drawer.querySelector('[data-drawer-view="browse"]');
      const detailView = drawer.querySelector('[data-drawer-view="detail"]');

      if (browseView && detailView) {
        qsa('[data-show-fabric-detail]', drawer).forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const variantId = btn.dataset.showFabricDetail;
            this.showFabricDetail(variantId, browseView, detailView);
          });
        });

        qsa('[data-back-to-browse]', drawer).forEach(btn => {
          btn.addEventListener('click', () => {
            browseView.style.display = '';
            detailView.style.display = 'none';
          });
        });
      }

      this.initDrawerSwatchVisuals(drawer);
      this.syncDrawerSwatches();

      const drawerBody = drawer.querySelector('.mk-fabric-drawer__body');
      const tabBtns = qsa('[data-drawer-tab]', drawer);
      const sections = qsa('[data-drawer-section]', drawer);

      if (drawerBody && tabBtns.length > 0 && sections.length > 0) {
        tabBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            const target = btn.dataset.drawerTab;
            const section = drawer.querySelector('[data-drawer-section="' + target + '"]');
            if (!section) return;
            const bodyTop = drawerBody.getBoundingClientRect().top;
            const sectionTop = section.getBoundingClientRect().top;
            drawerBody.scrollTo({
              top: drawerBody.scrollTop + (sectionTop - bodyTop) - 8,
              behavior: 'smooth'
            });
          });
        });

        const updateActiveTab = () => {
          let activeKey = sections[0].dataset.drawerSection;
          const threshold = drawerBody.getBoundingClientRect().top + 60;
          sections.forEach(s => {
            if (s.getBoundingClientRect().top <= threshold) {
              activeKey = s.dataset.drawerSection;
            }
          });
          tabBtns.forEach(btn => {
            const isActive = btn.dataset.drawerTab === activeKey;
            btn.classList.toggle('mk-drawer-tab-btn--active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        };
        drawerBody.addEventListener('scroll', updateActiveTab, { passive: true });
      }
    }

    showFabricDetail(variantId, browseView, detailView) {
      const swatchEl = this.fabricDrawer?.querySelector(`.mk-drawer-swatch[data-variant-id="${variantId}"]`);
      const variant = this.productData.variants.find(v => v.id === Number(variantId));
      if (!swatchEl || !variant) return;

      const data = {
        stoftype: swatchEl.dataset.stoftype || '',
        martindale: swatchEl.dataset.martindale || '',
        pilling: swatchEl.dataset.pilling || '',
        farveaegthed: swatchEl.dataset.farveaegthed || '',
        betraek: swatchEl.dataset.betraek || '',
        thumb: swatchEl.dataset.thumb || '',
        stofDisplay: swatchEl.dataset.stofDisplay || '',
        stofDisplayType: swatchEl.dataset.stofDisplayType || '',
        galleri: swatchEl.dataset.stofGalleri || '[]',
        fabricDisclaimer: swatchEl.dataset.fabricDisclaimer || '',
        materialType: swatchEl.dataset.materialType || '',
      };

      let galleryItems = [];
      try { galleryItems = JSON.parse(data.galleri) || []; } catch (e) {}
      const galleryEl = detailView.querySelector('[data-detail-gallery]');
      // Vis detail-viewet FOER galleriet renderes: ellers maales track.clientWidth til 0
      // (display:none), og pile/pagination beregnes forkert paa et ikke-layoutet element.
      browseView.style.display = 'none';
      detailView.style.display = '';
      if (galleryEl && window.MKFabricGallery) {
        window.MKFabricGallery.render(galleryEl, galleryItems);
      }

      const disclaimerEl = detailView.querySelector('[data-detail-disclaimer]');
      if (disclaimerEl) {
        // Block-setting fra drawer har forrang; falder tilbage til per-variant
        // metafield for legacy-produkter der stadig har det sat.
        const drawerDisclaimer = this.fabricDrawer?.getAttribute('data-fabric-disclaimer') || '';
        const disclaimerHtml = drawerDisclaimer || data.fabricDisclaimer || '';
        if (disclaimerHtml && galleryItems.length) {
          disclaimerEl.innerHTML = disclaimerHtml;
          disclaimerEl.hidden = false;
        } else {
          disclaimerEl.hidden = true;
        }
      }

      const maintenanceEl = detailView.querySelector('[data-detail-maintenance]');
      const maintenanceTextEl = detailView.querySelector('[data-detail-maintenance-text]');
      if (maintenanceEl && maintenanceTextEl) {
        const drawer = this.fabricDrawer;
        const mt = (data.betraek || data.materialType || '').toLowerCase();
        let text = drawer?.dataset.maintenanceDefault || '';
        if (mt === 'stof' && drawer?.dataset.maintenanceStof) text = drawer.dataset.maintenanceStof;
        else if (mt === 'fløjl' && drawer?.dataset.maintenanceFlojl) text = drawer.dataset.maintenanceFlojl;
        else if (mt === 'velour' && drawer?.dataset.maintenanceVelour) text = drawer.dataset.maintenanceVelour;
        else if (mt === 'læder' && drawer?.dataset.maintenanceLaeder) text = drawer.dataset.maintenanceLaeder;
        else if (mt === 'bouclé' && drawer?.dataset.maintenanceBoucle) text = drawer.dataset.maintenanceBoucle;
        if (text) {
          maintenanceTextEl.textContent = text;
          maintenanceEl.hidden = false;
        } else {
          maintenanceEl.hidden = true;
        }
      }

      const nameEl = detailView.querySelector('[data-detail-name]');
      if (nameEl) nameEl.textContent = variant.title?.split(' / ')[0] || variant.title;

      const stoftypeEl = detailView.querySelector('[data-detail-stoftype]');
      if (stoftypeEl) stoftypeEl.textContent = data.stoftype || '';

      const martindaleRow = detailView.querySelector('[data-detail-martindale-row]');
      const martindaleVal = detailView.querySelector('[data-detail-martindale]');
      const martindaleFill = detailView.querySelector('[data-detail-martindale-fill]');
      if (martindaleRow) {
        if (data.martindale) {
          martindaleRow.style.display = '';
          martindaleVal.textContent = data.martindale;
          const num = parseInt(String(data.martindale).replace(/\./g, ''), 10) || 0;
          let fill = 70;
          if (num >= 70000) fill = 100;
          else if (num > 45000) fill = 90;
          else if (num > 30000) fill = 80;
          else if (num >= 20000) fill = 70;
          else fill = 60;
          martindaleFill.style.width = fill + '%';
        } else {
          martindaleRow.style.display = 'none';
        }
      }

      const pillingRow = detailView.querySelector('[data-detail-pilling-row]');
      const pillingText = detailView.querySelector('[data-detail-pilling-text]');
      const pillingDots = detailView.querySelectorAll('[data-detail-pilling-dots] .mk-detail-dot');
      if (pillingRow) {
        if (data.pilling) {
          pillingRow.style.display = '';
          const pVal = parseInt(data.pilling, 10) || 0;
          pillingText.textContent = pVal + '/5';
          pillingDots.forEach((dot, i) => {
            dot.classList.toggle('mk-detail-dot--filled', i < pVal);
          });
        } else {
          pillingRow.style.display = 'none';
        }
      }

      const farveRow = detailView.querySelector('[data-detail-farveaegthed-row]');
      const farveText = detailView.querySelector('[data-detail-farveaegthed-text]');
      const farveDots = detailView.querySelectorAll('[data-detail-farveaegthed-dots] .mk-detail-dot');
      if (farveRow) {
        if (data.farveaegthed) {
          farveRow.style.display = '';
          const raw = String(data.farveaegthed);
          const fVal = parseInt(raw.split('/')[0], 10) || 0;
          farveText.textContent = raw.includes('/') ? raw : fVal + '/5';
          farveDots.forEach((dot, i) => {
            dot.classList.toggle('mk-detail-dot--filled', i < fVal);
          });
        } else {
          farveRow.style.display = 'none';
        }
      }

      const betraekRow = detailView.querySelector('[data-detail-betraek-row]');
      const betraekVal = detailView.querySelector('[data-detail-betraek]');
      if (betraekRow) {
        if (data.betraek) {
          betraekRow.style.display = '';
          betraekVal.textContent = data.betraek;
        } else {
          betraekRow.style.display = 'none';
        }
      }

    }

    initDrawerSwatchVisuals(drawer) {
      const { _colorSwatches = [], _imageSwatches = [] } = window.MinimogSettings || {};

      qsa('.mk-drawer-swatch__image.mk-option', drawer).forEach(node => {
        const label = node.querySelector('label');
        if (!label) return;

        // Skip hvis Liquid allerede har sat stof_thumbnail som background-image.
        if (label.style.backgroundImage) {
          label.classList.add('has-bg-img');
          return;
        }

        const { optionPosition, value } = node.dataset;
        if (!value) return;

        const valueLower = value.toLowerCase();
        const variantMatch = this.variantData?.find(v => v[`option${optionPosition}`] === value);
        const variantImage = variantMatch?.featured_image?.src || '';
        const customImage = _imageSwatches.find(i => i.key === valueLower)?.value;

        if (variantImage || customImage) {
          label.style.backgroundImage = `url(${customImage || variantImage})`;
          label.classList.add('has-bg-img');
        }
      });
    }

    initAutoFitSwatches() {
      const collapsed = this.container.querySelector('.mk-swatches--collapsed');
      if (!collapsed) {
        // Ingen collapsed-view → reveal alligevel så evt. skeleton fjernes.
        this.revealSwatchesAfterPreload();
        return;
      }

      const fitSwatches = () => {
        const swatches = qsa('.mk-option', collapsed);
        const expandBtn = collapsed.querySelector('.mk-swatch-expand');
        if (!swatches.length) return;

        swatches.forEach(s => s.removeAttribute('data-overflow-hidden'));
        if (expandBtn) expandBtn.style.display = '';
        // "+N" = antal skjulte swatches. Saet worst-case label FOER maaling, saa
        // knappens bredde indgaar korrekt i pladsberegningen (ellers hopper layoutet).
        const moreCountEl = expandBtn ? expandBtn.querySelector('[data-swatch-more-count]') : null;
        if (moreCountEl) {
          moreCountEl.hidden = false;
          moreCountEl.textContent = '+' + (swatches.length - 1);
          expandBtn.classList.add('has-count');
        }

        const containerWidth = collapsed.offsetWidth;
        const gap = 8;
        const swatchWidth = swatches[0].offsetWidth || 44;
        const expandBtnWidth = expandBtn ? (expandBtn.offsetWidth || swatchWidth) + gap : 0;
        const availableWidth = containerWidth - expandBtnWidth;
        const maxFit = Math.floor((availableWidth + gap) / (swatchWidth + gap));
        const hasOverflow = swatches.length > maxFit;

        swatches.forEach((swatch, i) => {
          if (hasOverflow && i >= maxFit) {
            swatch.setAttribute('data-overflow-hidden', '');
          }
        });

        if (moreCountEl) {
          const hiddenCount = hasOverflow ? swatches.length - maxFit : 0;
          if (hiddenCount > 0) {
            moreCountEl.textContent = '+' + hiddenCount;
          } else {
            moreCountEl.hidden = true;
            expandBtn.classList.remove('has-count');
          }
        }
        if (expandBtn) {
          expandBtn.style.display = hasOverflow ? '' : 'none';
        }
      };

      // Vent på layout-frame før fit, så reveal kan preload bg-images og crossfade i samme frame.
      requestAnimationFrame(() => {
        fitSwatches();
        this.revealSwatchesAfterPreload();
      });

      const ro = new ResizeObserver(() => fitSwatches());
      ro.observe(collapsed);
    }


    initLinkedProductDropdown() {
      const toggle = this.container.querySelector('[data-toggle-linked-dropdown]');
      const dropdown = this.container.querySelector('[data-linked-dropdown]');
      if (!toggle || !dropdown) return;

      const jsonEl = this.container.querySelector('[data-linked-variant-images]');
      if (jsonEl) {
        try { this.linkedVariantImages = JSON.parse(jsonEl.textContent); } catch (e) {}
      }

      toggle.addEventListener('click', () => {
        const open = dropdown.style.display !== 'none';
        dropdown.style.display = open ? 'none' : 'block';
        toggle.classList.toggle('mk-linked--open', !open);
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.mk-linked-product')) {
          dropdown.style.display = 'none';
          toggle.classList.remove('mk-linked--open');
        }
      });
    }

    updateLinkedProductImages() {
      if (!this.currentVariant || !this.linkedVariantImages) return;

      const currentColor = this.currentVariant.option1;

      const currentImg = this.container.querySelector('[data-linked-current-img]');
      if (currentImg && this.currentVariant.featured_image?.src) {
        currentImg.src = this.currentVariant.featured_image.src.replace(/(\.[^.]+)$/, '_120x$1');
      }

      const altImg = this.container.querySelector('[data-linked-alt-img]');
      if (altImg && currentColor && this.linkedVariantImages[currentColor]) {
        altImg.src = this.linkedVariantImages[currentColor];
      }
    }


    initLegModal() {
      const legOptions = this.container.querySelector('#mk-leg-options');
      if (!legOptions) return;

      this.legOptionsEl = legOptions;
      // Markup forvælger første ben visuelt når produktet ikke har default_ben.
      // Læs den forvalgte knap i stedet for at antage 'default', ellers sendes
      // intet ben med med mindre brugeren aktivt klikker.
      const preselectedLeg = legOptions.querySelector('.mk-leg-option--selected');
      this.selectedLegVariant = preselectedLeg?.dataset.legVariant || 'default';
      this.selectedLegPrice = parseInt(preselectedLeg?.dataset.legPrice, 10) || 0;
      this.selectedLegName = preselectedLeg?.dataset.legName || '';
      this.legProductHandle = this.productHandle;

      // Cylindo skal synces flere gange — viewer kan bootstrappe sent.
      const initCylindo = () => {
        const selected = legOptions.querySelector('.mk-leg-option--selected');
        if (selected?.dataset.legColorCode) {
          this.updateCylindoLeg(selected.dataset.legColorCode);
        }
      };
      initCylindo();
      setTimeout(initCylindo, 500);
      setTimeout(initCylindo, 2000);

      const saved = sessionStorage.getItem(`mk-leg-${this.legProductHandle}`);
      if (saved) {
        try {
          const data = JSON.parse(saved);
          this.selectLeg(data.variant, data.name, data.price, data.colorCode, false);
        } catch (e) {}
      }

      qsa('[data-toggle-leg-options]', this.container).forEach(btn => {
        btn.addEventListener('click', () => {
          legOptions.classList.toggle('mk-leg-options--visible');
        });
      });

      qsa('.mk-leg-option', legOptions).forEach(btn => {
        btn.addEventListener('click', () => {
          const { legVariant, legPrice, legColorCode, legName } = btn.dataset;
          this.selectLeg(legVariant, legName, legPrice, legColorCode, true);
          legOptions.classList.remove('mk-leg-options--visible');
        });
      });

      this.hasDefaultBen = !!legOptions.querySelector('[data-leg-variant="default"]');

      // Capture-phase intercept så product-form'ens egen submit-handler ikke firer.
      const form = this.section?.querySelector('form[action*="/cart/add"]');
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          await this.addToCartWithLegs(form);
          return false;
        }, true);
      }
    }

    async addToCartWithLegs(form) {
      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const quantity = formData.get('quantity') || 1;
      const productForm = form.closest('.product-form');

      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) {
          properties[match[1]] = value;
        }
      }

      if (productForm) productForm.classList.add('adding');

      try {
        const mainItem = {
          id: mainVariantId,
          quantity: parseInt(quantity)
        };

        // Benet sendes som property og bundles server-side af cart transform
        // "leg-bundle", i stedet for at blive tilføjet som selvstændig linje.
        let orderedProperties = properties;
        if (this.selectedLegVariant && this.selectedLegVariant !== 'default') {
          // Skjult GID som cart transform-funktionen validerer og ekspanderer på.
          properties['_ben'] = `gid://shopify/ProductVariant/${this.selectedLegVariant}`;
          // Synlig, læsbar label så kunden kan se sit ben-valg i kurven (vises først, under Farve).
          if (this.selectedLegName) {
            const benLabel = this.selectedLegName.charAt(0).toUpperCase() + this.selectedLegName.slice(1);
            orderedProperties = { 'Ben': benLabel, ...properties };
          }
        }

        if (Object.keys(orderedProperties).length > 0) {
          mainItem.properties = orderedProperties;
        }

        const items = [mainItem];

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        const data = await response.json();

        if (response.ok) {
          if (typeof Shopify !== 'undefined' && Shopify.onItemAdded) {
            Shopify.onItemAdded(data);
          }
          window.MinimogEvents?.emit('ON_ITEM_ADDED', data);

          try {
            const cartResp = await fetch('/cart.js');
            const cart = await cartResp.json();
            const countEl = document.querySelector('.sf-cart-count');
            if (countEl) countEl.innerText = cart.item_count;
          } catch (e) {}
        }
      } catch (error) {
        console.error('Cart error:', error);
      } finally {
        if (productForm) productForm.classList.remove('adding');
      }
    }

    selectLeg(variant, name, price, colorCode, save) {
      this.selectedLegVariant = variant;
      this.selectedLegPrice = parseInt(price) || 0;
      this.selectedLegName = name || this.selectedLegName || '';

      const nameEl = this.container.querySelector('[data-current-leg-name]');
      if (nameEl && name) nameEl.textContent = name;

      if (this.legOptionsEl) {
        qsa('.mk-leg-option', this.legOptionsEl).forEach(btn => {
          btn.classList.toggle('mk-leg-option--selected', btn.dataset.legVariant === variant);
        });
      }

      if (colorCode) this.updateCylindoLeg(colorCode);

      if (save) {
        sessionStorage.setItem(`mk-leg-${this.legProductHandle}`, JSON.stringify({
          variant, name, price, colorCode
        }));
      }
    }

    updateCylindoLeg(colorCode) {
      if (!colorCode) return;
      const mapped = (colorCode.toUpperCase() === 'KROM' || colorCode.toUpperCase() === 'CHROM') ? 'CHROME' : colorCode;
      const viewers = document.querySelectorAll('cylindo-viewer');
      viewers.forEach(viewer => {
        if (viewer && typeof viewer.features !== 'undefined') {
          try {
            const currentFeatures = { ...viewer.features };
            currentFeatures['Leg Finish'] = mapped;
            viewer.features = currentFeatures;
          } catch (e) {}
        }
      });
    }


    openFabricDrawer() {
      if (!this.fabricDrawer) return;
      const browse = this.fabricDrawer.querySelector('[data-drawer-view="browse"]');
      const detail = this.fabricDrawer.querySelector('[data-drawer-view="detail"]');
      if (browse) browse.style.display = '';
      if (detail) detail.style.display = 'none';
      this.syncDrawerSwatches();
      this.fabricDrawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('prevent-scroll');
      // iOS-scroll-laasen haandteres universelt i custom.js (mk-scroll-lock), som
      // reagerer paa prevent-scroll-klassen for ALLE drawers/modaler.
    }

    // Design selv-banneret i draweren goeres sticky, saa vilkaarene altid er synlige.
    // Naar det sidder fast under scroll, kollapses broedteksten til en kompakt linje
    // (titel + "Laes vilkaar"), saa det ikke aeder skaermplads paa mobil.
    initStickyDsBanner(drawer) {
      const body = drawer.querySelector('.mk-fabric-drawer__body');
      const banner = drawer.querySelector('.mk-drawer-ds-banner');
      if (!body || !banner) return;
      banner.classList.add('mk-drawer-ds-banner--sticky');
      // Sticky pinner ved bodyens padding-kant (ikke kant+0), saa en rect-sammenligning
      // mod body-toppen rammer aldrig. Standard-tricket: en 1px-sentinel lige foer
      // banneret – naar den er scrollet ud over toppen, sidder banneret fast.
      const sentinel = document.createElement('div');
      sentinel.style.cssText = 'height:1px;margin-bottom:-1px;';
      banner.parentNode.insertBefore(sentinel, banner);
      // Blur-lag BAG banneret (kan ikke laves som pseudo paa banneret selv, da den
      // ville male oven paa boksens baggrund). Pinner samme sted via sticky.
      const blurEl = document.createElement('div');
      blurEl.className = 'mk-drawer-ds-blur';
      banner.parentNode.insertBefore(blurEl, banner);
      const io = new IntersectionObserver((entries) => {
        const e = entries[0];
        const above = !e.isIntersecting && e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0);
        banner.classList.toggle('is-stuck', above);
        blurEl.classList.toggle('is-stuck', above);
      }, { root: body, threshold: 0 });
      io.observe(sentinel);
    }

    closeFabricDrawer() {
      if (!this.fabricDrawer) return;
      this.fabricDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('prevent-scroll');
      const browse = this.fabricDrawer.querySelector('[data-drawer-view="browse"]');
      const detail = this.fabricDrawer.querySelector('[data-drawer-view="detail"]');
      if (browse) browse.style.display = '';
      if (detail) detail.style.display = 'none';
    }
  }

  customElements.define('mk-variant-picker', MkVariantPicker);
}
